import { render, staticRenderFns } from "./multiple-profile-default-v2.vue?vue&type=template&id=d6c5b102&scoped=true&"
import script from "./multiple-profile-default-v2.vue?vue&type=script&lang=js&"
export * from "./multiple-profile-default-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c5b102",
  null
  
)

export default component.exports